import type { IconProps } from '@chakra-ui/icons'
import { createIcon } from '@chakra-ui/icons'
import type { ComponentWithAs } from '@chakra-ui/react'

export const CircleIcon: ComponentWithAs<'svg', IconProps> = createIcon({
  displayName: 'Circle',
  viewBox: '0 0 200 200',
  path: (
    <>
      <circle cx="81" cy="81" r="80.5" fill="black" stroke="black" />
      <path fill="currentColor" d="M 100, 100 m -75, 0 a 75,75 0 1,0 150,0 a 75,75 0 1,0 -150,0" />
    </>
  ),
})
